export default "__VITE_PUBLIC_ASSET__45983c4a__"